import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";

import styles from "./StoreWarrantySummary.module.scss";

const cx = classNames.bind(styles);

export type StoreWarrantySummaryProps = {
    months?: number;
    store?: string;
    inTransit?: boolean;
    isComingSoon?: boolean;
};

const StoreWarrantySummary = ({
    store,
    months,
    inTransit = false,
    isComingSoon = false,
}: StoreWarrantySummaryProps) => (
    <div className={cx("storeWarranty")}>
        {!!months && (
            <span className={cx("warranty")}>
                <UIIcon icon="Warranty" className={cx("warrantyIcon")} />
                {months} month{months > 1 ? "s" : ""} warranty
            </span>
        )}
        {!!store && !isComingSoon && (
            <SmartLink href={`${process.env.NEXT_PUBLIC_APP_URL}/stores/${store.toLowerCase()}`}>
                <a target="_blank" className={cx("store")}>
                    <UIIcon
                        icon={inTransit ? "InTransit" : "PropertyLocation"}
                        className={cx("storeIcon", { inTransit })}
                    />
                    {inTransit && "In transit to our"} {store} store
                </a>
            </SmartLink>
        )}
    </div>
);

export default StoreWarrantySummary;
